import { dayjs, esLocale, formatDate } from '@/plugins/dayjs_intercom'
import locale from 'ant-design-vue/es/date-picker/locale/es_ES';
import { ref } from 'vue';
import { search_bcv } from '@/plugins/odoo'
const amountDollars = ref({});
const amountVES = ref({});
const tasaBCV = ref({});
const rateOdoo = 2; // rate ODOO para $

const manageConvert = async (myDate, myAmount, operation) => {
    myDate = formatDate(myDate, "YYYY-MM-DD");
    const bcv_value = await search_tasa_bcv(myDate)
    let amount = ''
    if (bcv_value.rate_inverse !== 0) {
      // amountDollar = parseFloat(item.amount / bcv_value).toFixed(2) + "$";
      if (operation === "VESUSD") {
        amount = parseFloat(myAmount / bcv_value).toFixed(2);
      }
      if (operation === "USDVES") {
        amount = parseFloat(myAmount * bcv_value).toFixed(2);
      }
    } else {
      amount = "Monto no disponible, intentelo más tarde"
    }
    return amount;
}
const search_tasa_bcv = async (myDate) => {
  if (tasaBCV.value[myDate] === undefined) {
      const bcv = await search_bcv(rateOdoo, myDate);
      if (bcv != undefined) {
        tasaBCV.value[myDate] = bcv.rate_iverse
      } else {
        tasaBCV.value[myDate] = 0
        console.log("Tasa no conseguida" + bcv)
      }
  }
  // console.log(myDate + ' ' + tasaBCV.value[myDate])
  return tasaBCV.value[myDate]; // Devolver el valor existente
}
const formatAmountVES = async(item) => {
    let amountVes = '';
    switch(item.payment_method_code) {
        case "paypal_new":
          amountVes = manageConvert(item.date, item.amount, "USDVES");
          break;
        default:
          amountVes = item.amount
      }
      return amountVes
  }
// const formatAmountDollar = async (item) => {
//     try {
//       let amountDollar = '';
//       if (!item.payment_method_code && item.move_type) { 
//         console.log(item.name.includes("Pppl"))
//         console.log(item.name.includes("P105") || item.name.includes("P134"))
//         if (item.name.includes("Pppl")) {
//           amountDollar = item.amount_total.toFixed(2);
//         }
//         if (item.name.includes("P105") || item.name.includes("P134")) {
//           amountDollar = manageConvert(item.date, item.amount_total, "VESUSD");
//         }
//       } else {
//         switch(item.payment_method_code) {
//           case "paypal_new":
//             amountDollar = item.amount.toFixed(2);
//             break;
//           default:
//             amountDollar = manageConvert(item.date, item.amount, "VESUSD");
//         }
//       }
//       return parseFloat(amountDollar) 
//     } catch (error) {
//       console.error('Error al buscar el monto en BCV:', error);
//       return 'Error al cargar';
//     }
// }
const convert_currency_id_name = (currency_id) => {
  switch(currency_id) {
    case 1:
      return "EUR";
    case 2:
      return "USD";
    case 3:
      return "VES";
  }
}
const convert_amount = (amount, dateCheck, typeMoney) => {
  let amountDollar = '';
  switch(typeMoney) {
    case "USD":    
      amountDollar = amount.toFixed(2);
      break;
    default:
      amountDollar = manageConvert(dateCheck, amount, "VESUSD");
      break;
  }
  return amountDollar;
}
const formatAmountDollar = async (item) => {
  let typeMoney = ''
  if (Number.isInteger(item.currency_id)) {
    typeMoney = convert_currency_id_name(item.currency_id)
  } else {
    typeMoney = item.currency_id
  }
  const amount_check = (item.amount) ? item.amount : item.amount_total
  return convert_amount(amount_check, item.invoice_date, typeMoney)
}
const formatAmountDollarInvoice = async (item) => {
  let typeMoney = ''
  if (Number.isInteger(item.currency_id)) {
    typeMoney = convert_currency_id_name(item.currency_id)
  } else {
    typeMoney = item.currency_id
  }
  const amount_check = (typeMoney == 'VES') ? item.amount_total_signed : item.amount_total;
  return convert_amount(amount_check, item.invoice_date_due, typeMoney)
}
const formatPaymentMethod = (payment_method_code) => {
    let my_payment_method_code = '';
    switch(payment_method_code) {
      case 'bp_online':
        my_payment_method_code = "BIOPAGO ONLINE"
        break;
      case 'manual':
        my_payment_method_code = "EFECTIVO"
        break;
      case 'pg_movil':
        my_payment_method_code = "PAGO MÓVIL"
        break;
      case 'paypal_new':
        my_payment_method_code = "PAYPAL"
        break;
      case 'transfer':
        my_payment_method_code = "TRANSFERENCIA"
        break;
    }
    return my_payment_method_code;
}
const formatInvoiceState = (invoice_state, credit_note = false) => {
  switch(invoice_state) {
    case "not_paid":
        return "EMITIDA"
    case "partial":
        return "PARCIAL"
    case "paid":
        if (credit_note == false) {
          return "PAGADO"
        } else {
          return "APLICADO"
        }
        
  }
}
function paymentColor(datePayment, statePayment, credit_note = false) {
  if (statePayment === "paid") {
    return "green"
  } else {
    const diffInDays = ref(0)
    if (credit_note == false) {
      const currentDate = dayjs();
      diffInDays.value = currentDate.diff(dayjs(datePayment), 'days');
    } 
    if (diffInDays.value <= 0) {
        return "blue"
    }
    if (diffInDays.value == 1) {
        return "yellow"
    }
    if (diffInDays.value > 1) {
        return "red"
    }   
  }
}
const formatState = (state) => {
  // console.log(state)
  let my_state = '';
  switch(state) {
    case false:
      my_state = "PROCESADO"
      break;
    case "pending":
        my_state = "VERIFICANDO"
        break
    case "cancel":
      my_state = "NO APROBADO"
      break;
    case "done":
      my_state = "CONFIRMADO"
      break;
  }
  return my_state
}
const formStateColor = (state) => {
    switch(state) {
      case false:
        return "green"
      case "pending":
        return "blue"
      case "cancel":
        return "red"
      case "done":
        return "green"
    }
}

const TitleServiceCut = (display_name) => {
  // console.log(display_name)
  let arrayCut = display_name.split(" - ");
  return arrayCut
}
const disabledDate = (current) => {
  // Desactivar fechas posteriores a la fecha actual
  return current && current > dayjs().endOf('day');
}
const disabledRange = (current, startDate, endDate) => {
  // Desactivar fechas posteriores a la fecha actual
  // console.log(current + ' '+ startDate+ ' ' + endDate)
  const start = startDate;
  const end = endDate;
  return current && (current.isBefore(start) || current.isAfter(end));
}
const range_init = (from, to = undefined) => {
  from = dayjs(formatDate(from, "YYYY-MM-DD"))
  if (to == undefined) {
    to = dayjs()
  } else {
    to = dayjs(formatDate(to, "YYYY-MM-DD"))
  }
  // console.log(from)
  // console.log(to)
  return [from, to]
}
const switchColumnsTable = (typeColumn)  => {
  switch (typeColumn) {
    case 'invoices':
      return columns_invoice
    case 'payment':
      return columns_payment
    case 'statment':
      return columns_statment
  }
}

export { 
  dayjs,
  esLocale,
  formatDate, 
  switchColumnsTable, 
  manageConvert,
  formStateColor, 
  formatState, 
  formatInvoiceState, 
  formatAmountDollarInvoice,
  formatAmountDollar,
  formatAmountVES,
  formatPaymentMethod,
  paymentColor, 
  disabledDate,
  disabledRange,
  range_init,
  TitleServiceCut,
  convert_currency_id_name
}